export default "__VITE_ASSET__fkx1OMoq__"